// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Owrt","image":"Header_image__5xzfu","name":"Header_name__2O2GI","info":"Header_info__3gnSY","infoRow":"Header_infoRow__2DjEa"};